import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languageStyle = {
    cursor: 'pointer',
    padding: '5px 10px',
    color: 'white',
    opacity: 0.8,
    transition: 'opacity 0.3s ease',
    fontSize: 'inherit',
    fontWeight: 'normal'
  };

  const activeStyle = {
    ...languageStyle,
    opacity: 1,
    fontWeight: 'bold',
    textDecoration: 'underline'
  };

  return (
    <div style={{ 
      display: 'flex', 
      gap: '5px', 
      alignItems: 'center',
      marginLeft: '20px',
      marginTop: window.innerWidth <= 768 ? '30px' : '0'
    }}>
      <span
        style={i18n.language === 'pt' ? activeStyle : languageStyle}
        onClick={() => changeLanguage('pt')}
      >
        PT
      </span>
      <span style={{ color: 'white', opacity: 0.8 }}>|</span>
      <span
        style={i18n.language === 'en' ? activeStyle : languageStyle}
        onClick={() => changeLanguage('en')}
      >
        EN
      </span>
      <span style={{ color: 'white', opacity: 0.8 }}>|</span>
      <span
        style={i18n.language === 'fr' ? activeStyle : languageStyle}
        onClick={() => changeLanguage('fr')}
      >
        FR
      </span>
      <span style={{ color: 'white', opacity: 0.8 }}>|</span>
      <span
        style={i18n.language === 'es' ? activeStyle : languageStyle}
        onClick={() => changeLanguage('es')}
      >
        ES
      </span>
    </div>
  );
};

export default LanguageSelector;
